"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/DZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_64)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_64`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.23999 0H29.76V24H-6.23999V0Z",
					fill: "#41662E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.76 0H29.76V24H11.76V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.7249 7.38947L15.6617 10.2246L12.3284 9.14385L14.3916 11.9789L12.3284 14.814L15.6617 13.7333L17.7249 16.5684V13.0596L21.0582 11.9719L17.7249 10.8912V7.38947Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.5074 19.4175C11.4021 19.4175 8.06877 16.0842 8.06877 11.9789C8.06877 7.87368 11.4021 4.54034 15.5074 4.54034C16.7916 4.54034 17.9916 4.86315 19.0442 5.43157C17.3951 3.81754 15.1354 2.82104 12.6442 2.82104C7.59158 2.82104 3.49333 6.91929 3.49333 11.9719C3.49333 17.0246 7.59158 21.1228 12.6442 21.1228C15.1354 21.1228 17.3951 20.1263 19.0442 18.5123C17.9986 19.0877 16.7916 19.4175 15.5074 19.4175Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_64`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as DZFlag };
